import { newE2EPage } from "@stencil/core/testing";

describe("table-head-sort", () => {
    it("should render a component", async () => {
        const page = await newE2EPage();
        await page.setContent(`<uic-table-head-sort></uic-table-head-sort>`);
        const el = await page.find("uic-table-head-sort");
        expect(el).toHaveClass("hydrated");
    });

    it("should match in empty state to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(`<uic-table-head-sort ></uic-table-head-sort>`);
        const el = await page.find("uic-table-head-sort");
        expect(el).toMatchSnapshot();
    });
});
